module.exports = __webpack_public_path__ + "img/login.7b1b75f7.gif";